//  获取地址栏信息
export function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
//指定位数拆分字符串
export function getStrArr(source, count) {
  let arr = [];
  for (let i = 0, len = source.length / count; i < len; i++) {
    let subStr = source.substr(0, count);
    arr.push(subStr);
    source = source.replace(subStr, "");
  }
  return arr;
}
// base64转二进制流
export function dataURItoBlob (dataURI) {
  // base64 解码
  let byteString = window.atob(dataURI.split(',')[1]);
  let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  let T = mimeString.split('/')[1]
  let ab = new ArrayBuffer(byteString.length);
  let ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], {type: mimeString});
}
// 关键字飘红
export function keywordLight(
    content = "",
    keywords = [],
    replace = (content, word) => {
        const copy = word;
        for (let k of [
            "\\", "(", ")", "{", "}", "[", "]", "|", "$", "&", "?", "^", "!", "+", "*", ".", "-", "/", ":",
        ]) {
            word = word.replace(RegExp(`\\${k}`, "gm"), `\\${k}`);
        }
        return `<span style="color:tomato">${copy}</span>`;
    }
) {
    function strProcess(keyword) {
        return keyword === ">" || keyword === "<" || keyword === "/";
    }

    const result = [];
    const copy = content.toLocaleLowerCase();

    function addResult(data) {
        if (result.length > 0) {
            let max = result[result.length - 1];
            if (data[0] <= max[1]) {
                if (data[0] >= max[0] && data[1] <= max[1]) return;
                max[1] = data[1];
                if (data[0] < max[0]) max[0] = data[0];
                return;
            }
        }
        result.push(data);
    }

    function suffixEq(copy, word, index) {
        for (let i = word.length - 2, j = 0; i >= 0; i--, j++) {
            if (word[i] !== copy[index - j - 1]) return false;
        }
        return true;
    }

    for (let i = 0; i < copy.length; i++) {
        const char = copy[i];
        for (let word of [...keywords]) {
            word = word.toLocaleLowerCase();
            if (strProcess(word)) continue;
            let wordChar = word[word.length - 1];
            if (wordChar === char) {
                if (suffixEq(copy, word, i)) {
                    addResult([i - word.length + 1, i]);
                }
            }
        }
    }

    let words = result.map((data) => content.substring(data[0], data[1] + 1));
    words.sort((v, v1) => {
        if (v === "em") return -1;
        if (v1 === "em") return 1;
        return v.length < v1.length ? 1 : -1;
    });

    // 使用占位符替换关键字
    const placeholderMap = new Map();
    let output = content;

    for (let word of words) {
        const placeholder = `\x00${word}\x00`; // 使用唯一的占位符
        placeholderMap.set(placeholder, replace(output, word));
        const regex = new RegExp(word, "g");
        output = output.replace(regex, placeholder);
    }

    // 将占位符替换为最终的 <span> 标签
    for (let [placeholder, replacement] of placeholderMap) {
        output = output.replace(new RegExp(placeholder, "g"), replacement);
    }

    return output;
}
// 上传文件真实名称
export function substringName(valStr){
    let suffx = valStr.substring(valStr.lastIndexOf("."))
    return valStr.substring(valStr.indexOf('/') + 1,valStr.lastIndexOf("_")) + suffx
}